/**
 * The current page's navigation type — 'reload' | 'navigate' | 'back_forward' —
 * or 'unknown' when it can't be determined. This is the reload-storm signal: a
 * client stuck re-booting shows repeated `reload` boots.
 *
 * Fully defensive — getEntriesByType may be missing or (off-spec) return a
 * non-array, the entry may be absent, and the PerformanceNavigationTiming global
 * may not exist for the instanceof. Any of these degrades to 'unknown' rather
 * than throwing. instanceof narrows the base entry without a cast.
 */
export function getNavigationType(): string {
  try {
    const entries = performance.getEntriesByType('navigation')
    const navEntry = Array.isArray(entries) ? entries[0] : undefined
    if (
      typeof PerformanceNavigationTiming !== 'undefined' &&
      navEntry instanceof PerformanceNavigationTiming
    ) {
      return navEntry.type
    }
  } catch {
    // performance API unavailable or nonstandard — never break the caller.
  }
  return 'unknown'
}
